// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueScrollactive from 'vue-scrollactive'
import App from './AdminApp'
import store from './store'
import router from './router/admin.index'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import UUID from 'vue-uuid'
import IdleVue from 'idle-vue-2'
import moment from 'moment'
import Tracker from '@openreplay/tracker'
import trackerAssist from '@openreplay/tracker-assist'
import api from '@/api'
import { ConsoleLog } from '@openreplay/tracker/lib/common/messages'


Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_APILOCATION
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"
axios.defaults.xsrfCookieName = "csrftoken"
axios.defaults.withCredentials = true

const token = localStorage.getItem('user-token')
const expire = localStorage.getItem('user-token-expiry')
const user = localStorage.getItem('user-name')
const name = localStorage.getItem('user-full-name')
const admin = JSON.parse(localStorage.getItem('user-admin'))
const su = JSON.parse(localStorage.getItem('user-su'))
const id = localStorage.getItem('user-id')
const localSessionAuth = localStorage.getItem('user-session-auth')
const eventMonitor = new Vue()
const options = {
  eventEmitter: eventMonitor,
  idleTime: 3000
}


api.auth.currentuser.get()
  .then((data) => {
    store.dispatch('auth/setCookieSession', {
      user: data.username,
      name: `${data.first_name} ${data.last_name}`,
      id: data.id,
      admin: data.is_org_admin || false,
      su: data.is_staff || false,
      reset: data.reset || false
    })
  })
  .catch(() => {
    if (token) {
      store.dispatch('auth/setSession', { token, expire, user, name, id, admin, su, storage: true})
    } 
  })

Vue.use(VueScrollactive)
Vue.use(Vuetify)
Vue.use(IdleVue, options)
Vue.use(UUID)

const tracker = new Tracker({
  projectKey: "AsPUUy0idqVZNj4Y9nwF",
  ingestPoint: "https://session.corp.caselocker.app/ingest",
  network: {
    capturePayload: true,
  },
  __DISABLE_SECURE_MODE: process.env.NODE_ENV !== "production"
})
tracker.use(trackerAssist())
import { mapGetters, mapMutations } from 'vuex'

Vue.mixin({
  data () {
    return {
      isProduction: (process.env.NODE_ENV === "production"),
      PERMISSIONS: {
        NO_ACCESS: 10,
        CAN_VIEW: 20,
        CAN_CONTACT_EDIT: 30,
        CAN_EDIT: 40,
        CAN_CREATE: 50,
        CAN_BULK: 60,
        CAN_DELETE: 70
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'getDomainInfo',
      'isSessionAuth',
      'userInfo'
    ]),
    app_name () {
      return this.getDomainInfo.app_name || null
    }
  },
  methods: {
    getTracker() {
      return tracker
    },
    checkPermission (scope, limit) {
      if (this.getDomainInfo)
        if (this.getDomainInfo.permissions)
          return this.getDomainInfo.permissions[scope] >= limit
      return true
    },
    parsePlaceholder (html, placeholders) {
      if (placeholders && html) {
        const regex = /{{(\w+)\.(\w+)}}/g
      
        const convertedHtml = html.replace(regex, (match, scope, variable) => {
          var tmp = placeholders.filter(item => item['scope'] == scope && item['variable'] == variable)
          var name = "unknown"
          var icon = "mdi-tooltip-question-outline"
          if (tmp.length == 1)
            name = tmp[0]['name']
          if (scope == "contact")
            icon = "mdi-account"
          return `<span data-variable-placeholder scope="${scope}" variable="${variable}" class="placeholder-chip"><span class="mdi mdi-account"></span>${name}</span>`
        });

        return convertedHtml
      } else {
        return html
      }
    },
    startTracker(userInfo) {
      var domain = /:\/\/([^\/]+)/.exec(window.location.href)[1]
      tracker.stop()
      tracker.start({
        userID: userInfo['name'],
        metadata: {
          admin: 'true',
          client: 'false',
          dev: !this.isProduction,
          org: this.isProduction ? domain : 'localhost',
          is_admin: JSON.stringify(userInfo['admin']),
          su: JSON.stringify(userInfo['su']),
          username: userInfo['username'],
          user_id: userInfo['id'],
        }
      })
    },
    documentTitle (subTitle) {
      if (this.getDomainInfo.app_name)
        document.title = subTitle + " | " + this.getDomainInfo.app_name
      else
        document.title = subTitle
    },
    convertToLocal (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss')
      return local
    },
    convertToCalRef (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).calendar()
      return local
    },
    convertToPeriodicRef (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).fromNow()
      return local
    },
    resortTags (tagsArray) {
      var frontArray = []
      var backArray = []
      tagsArray.forEach((item) => {
        if (item.includes(":"))
          frontArray.push(item)
        else
          backArray.push(item)
      })

      return frontArray.concat(backArray)
    },
    getSignResponse (status) {
      switch (status.toLowerCase()) {
        case 'created':
          return 'Waiting for others...'
        case 'sent':
          return 'Signature Requested'
        case 'delivered':
          return 'Opened'
        case 'signed':
        case 'completed':
          return 'Signed'
        case 'declined':
          return 'Declined to Sign'
        case 'autoresponded':
          return 'Failed to Deliver'
        case 'faxpending':
          return 'Fax Pending'
        case 'cancelled':
          return 'Cancelled'
      }
    },
    getRootDomain () {
      var hostname = window.location.hostname
      var domainParts = hostname.split('.');
      if (domainParts.length > 2) {
        return domainParts.slice(-2).join('.');
      } else {
        return hostname;
      }    
    },
    isLegacyDomain () {
      return this.getRootDomain() == "litigationlocker.com"
    },
    isNewDomain () {
      return this.getRootDomain() == "caselocker.com"
    }
  }
})

if (process.env.NODE_ENV === "production") {
  Vue.config.silent = true
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})
